import React, { useMemo } from "react"
import { twMerge } from "tailwind-merge"

interface SocialProofWrapperTargetViewportClassNameProps {
  width: string
  borderRadius: string
  boxShadow: string
  position: string
  animationIn: string
  animationOut: string
}

const DESKTOP_WRAPPER_CLASSNAME: SocialProofWrapperTargetViewportClassNameProps = {
  width: "w-[352px]", // Set as width to prevent "squishing" of content on long texts
  borderRadius: "rounded-[12px]",
  boxShadow: "shadow-[0px_0px_48px_0px_#0B395433]",
  position: "bottom-3 left-3",
  animationIn: "translate-x-0 opacity-100",
  animationOut: "translate-x-[-120%] opacity-0"
}

const MOBILE_WRAPPER_CLASSNAME: SocialProofWrapperTargetViewportClassNameProps = {
  width: "max-w-[493px]", // Set as maxWidth to allow responsive appearance on very small viewports
  borderRadius: "rounded-b-none rounded-t-[12px]",
  boxShadow: "shadow-[0px_-8px_8px_0px_#0B39541F]",
  position: "inset-x-0 bottom-0",
  animationIn: "translate-y-0 opacity-100",
  animationOut: "translate-y-[140%] opacity-0"
}

const getWrapperAnimationClassName = (
  targetViewPortClassName: SocialProofWrapperTargetViewportClassNameProps,
  isVisible: boolean
) => {
  return isVisible ? targetViewPortClassName.animationIn : targetViewPortClassName.animationOut
}

export function SocialProofWrapper({
  isMobile,
  isVisible,
  children
}: Readonly<{ isMobile: boolean; isVisible: boolean; children: React.ReactNode }>) {
  const targetViewPortClassNameObj = useMemo(
    () => (isMobile ? MOBILE_WRAPPER_CLASSNAME : DESKTOP_WRAPPER_CLASSNAME),
    [isMobile]
  )

  return (
    <div
      className={twMerge(
        "fixed z-[999998] border border-[#E4EFF6] bg-white/95 transition-all duration-500",
        targetViewPortClassNameObj.width,
        targetViewPortClassNameObj.borderRadius,
        targetViewPortClassNameObj.boxShadow,
        targetViewPortClassNameObj.position,
        getWrapperAnimationClassName(targetViewPortClassNameObj, isVisible)
      )}>
      {children}
    </div>
  )
}
